"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=7%3A263))
 * @lastsynced 2026-10-29T13:48:45.288Z
 * @trackcomponent
 * @optimized using svgo:^3.3.4
 */
export const ArrowRight = createSVGIcon(
  <path
    d="M1 12h22m-6-6 6 6-6 6"
    strokeLinecap="round"
    strokeLinejoin="round"
    stroke="currentColor"
  />,
  "ArrowRight",
  {
    viewBox: "0 0 24 24",
    color: iconColor.primary,
    fill: "none",
    className: iconCls(),
  }
);
